import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 70.2 40.5" {...props}><path className={styles["st0"] || "st0"} d="M33 40.2l5.2-5.2-14.7-14.7v-.1L38.2 5.5 33 .3 16.7 16.6H.2v7.3h16.5z" /><path className={styles["st0"] || "st0"} d="M69.9 16.6H47.1L58.2 5.5 53 .3 33 20.2l20 20 5.2-5.2-11.1-11.1h22.8z" /></svg>;